import { render } from "./MobileSplashScreen.vue?vue&type=template&id=1c5e1c36&scoped=true"
import script from "./MobileSplashScreen.vue?vue&type=script&lang=js"
export * from "./MobileSplashScreen.vue?vue&type=script&lang=js"

import "./MobileSplashScreen.vue?vue&type=style&index=0&id=1c5e1c36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5e1c36"]])

export default __exports__